const LOGIN_SCREENS = {
    MAIN_LOGIN: 'MAIN_LOGIN',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    MFA_LOGIN: 'MFA_LOGIN',
    NO_MFA_ACCESS: 'NO_MFA_ACCESS'
};

export default LOGIN_SCREENS;